
import React from 'react';
import { Smartphone } from 'lucide-react';

interface MessagePreviewProps {
  message: string;
  optOutMessage: string;
}

const MessagePreview: React.FC<MessagePreviewProps> = ({
  message,
  optOutMessage
}) => {
  // Format message with personalization highlights for preview
  const formatMessageWithHighlights = () => {
    if (!message) return 'No message composed';
    
    // Replace personalization variables with highlighted spans
    let formattedMessage = message;
    const variablePattern = /{(.*?)}/g;
    
    // Check if there are any variables
    if (variablePattern.test(message)) {
      // Reset the regex lastIndex
      variablePattern.lastIndex = 0;
      
      // Replace each variable with a highlighted version
      formattedMessage = message.replace(variablePattern, (match, variable) => {
        return `<span class="bg-primary/20 text-primary rounded px-1">[${variable}]</span>`;
      });
    }
    
    // Return formatted message with opt-out message for preview only
    return `
      <div class="text-foreground">${formattedMessage}</div>
      <div class="mt-2 text-muted-foreground text-sm">${optOutMessage}</div>
    `;
  };

  return (
    <div className="bg-muted p-4 rounded-md mt-4">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium">Message Preview</p>
          <p className="text-muted-foreground text-xs mb-2">
            Variables will be replaced with customer data when sent
          </p>
        </div>
        <Smartphone className="h-5 w-5" />
      </div>
      <div className="mt-2 p-3 bg-background rounded border text-sm">
        <div dangerouslySetInnerHTML={{ __html: formatMessageWithHighlights() }} />
      </div>
    </div>
  );
};

export default MessagePreview;
